import { api } from './api'

export const notificationsService = {
  /* Lista paginada de notificaciones del usuario autenticado (recipient-only, scoped por tenant) */
  async getAll({ page = 1, limit = 20, unreadOnly = false } = {}) {
    try {
      const params = new URLSearchParams({ page: String(page), limit: String(limit) })
      if (unreadOnly) params.set('unread_only', 'true')
      return await api.get(`/notifications?${params.toString()}`, true)
    } catch (error) {
      console.error('[NotificationsService] getAll:', error)
      throw error
    }
  },

  /* Marca una notificación propia como leída (404 si no existe o no pertenece al usuario) */
  async markRead(id) {
    try {
      return await api.patch(`/notifications/${id}/read`, {}, true)
    } catch (error) {
      console.error('[NotificationsService] markRead:', error)
      throw error
    }
  },

  /* Marca todas las notificaciones no leídas del usuario/tenant activo como leídas */
  async markAllRead() {
    try {
      return await api.patch('/notifications/read-all', {}, true)
    } catch (error) {
      console.error('[NotificationsService] markAllRead:', error)
      throw error
    }
  }
}
